export default __webpack_public_path__ + "static/media/bannerBig10.20e9a2f6.png";